import jwt from 'jsonwebtoken'
import _ from 'lodash'
import backend from '../../components/utils/backend'

const debouncedUserProfileUpdate = _.debounce((userId, userProfile, accessToken) => {
  return new Promise(async (resolve, reject) => {
    try {
      const userInfo = (await backend.put(`/api/v1/user/${userId}`, accessToken, userProfile)).body
      resolve(userInfo)
    } catch (error) {
      reject(error)
    }
  })
}, 1000)

export default {
  state: {
    ssoToken: undefined,
    accessToken: undefined,
    decodedAccessToken: undefined,
    locale: undefined,
    userProfile: undefined
  },
  mutations: {
    'SET_SSO_TOKEN': function (state, ssoToken) {
      state.ssoToken = ssoToken
    },
    'SET_ACCESS_TOKEN': function (state, accessToken) {
      state.accessToken = accessToken
      localStorage.setItem('ACCESS_TOKEN', accessToken)
      if (accessToken) state.decodedAccessToken = jwt.decode(accessToken)
    },
    'SET_LOCALE': function (state, locale) {
      state.locale = locale
    },
    'SET_USER_PROFILE': function (state, userProfile) {
      state.userProfile = userProfile
    }
  },
  actions: {
    login ({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          // console.log('login')
          const mcAuthEndpoint = process.env.VUE_APP_MC_BASE_URI + '.auth.marketingcloudapis.com/v2/authorize?response_type=code'
          window.location.href = mcAuthEndpoint + '&client_id=' + process.env.VUE_APP_MC_CLIENT_ID + '&scope=' + process.env.VUE_APP_MC_SCOPES + '&redirect_uri=' + process.env.VUE_APP_MC_AUTH_REDIRECT_URI
        } catch (error) {
          reject(error)
        }
      })
    },
    doSSO ({ commit, getters }, ssoToken) {
      return new Promise(async (resolve, reject) => {
        try {
          // console.log('SSO')
          commit('SET_SSO_TOKEN', ssoToken)
          const authData = (await backend.post('/api/v1/auth', null, { code: ssoToken })).body
          commit('SET_ACCESS_TOKEN', authData.access_token)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    fetchUserProfile ({ commit, getters }, vm) {
      return new Promise(async (resolve, reject) => {
        try {
          const userInfo = (await backend.get(`/api/v1/user/${getters.userId}`, getters.accessToken)).body
          commit('SET_USER_PROFILE', userInfo)
          commit('SET_LOCALE', userInfo.locale)
          vm.$i18n.locale = userInfo.locale
          resolve(userInfo)
        } catch (error) {
          reject(error)
        }
      })
    },
    updateUserProfile ({ commit, getters }, userProfile) {
      commit('SET_USER_PROFILE', userProfile)
      commit('SET_LOCALE', userProfile.locale)
      debouncedUserProfileUpdate(getters.userId, getters.userProfile, getters.accessToken)
    },
    logout ({ commit }) {
      commit('SET_ACCESS_TOKEN', undefined)
      localStorage.removeItem('ACCESS_TOKEN')
    },
    changeLocale ({ commit, getters, dispatch }, locale) {
      let profile = getters.userProfile
      profile.locale = locale
      dispatch('updateUserProfile', profile)
    },
    setAccessToken ({ commit }, jwt) {
      commit('SET_ACCESS_TOKEN', jwt)
    }
  },
  getters: {
    locale: state => (state.userProfile && state.userProfile.locale) || 'en',
    role: state => (state.decodedAccessToken && state.decodedAccessToken.role) || null,
    userId: state => (state.decodedAccessToken && state.decodedAccessToken.sub),
    decodedAccessToken: state => state.decodedAccessToken,
    accessToken: state => state.accessToken,
    userProfile: state => state.userProfile,
    userVisibilities: state => state.decodedAccessToken.scopes && state.decodedAccessToken.scopes.filter(visibility => visibility.startsWith('CAMPAIGN_')),
    scopes: state => state.decodedAccessToken && state.decodedAccessToken.scopes
  },
  namespaced: true
}
